function updateAvCountries(state, countries) {
    state.avCountries = countries
}

function updateActiveCountry(state, country) {
    state.activeCountryId = country
}

export default {
    updateActiveCountry,
    updateAvCountries
}
